import gql from 'graphql-tag';

const OrganizationQuery = gql`
  query OrgLoaderQuery($id: String!) {
    ThirdPartyOrganizationEmailDomainsV1Resource {
      get(id: $id) {
        id
        thirdPartyOrganizationId
      }
    }
  }
`;

export { OrganizationQuery };
